import { getPortalToken, clearPortalSession, PORTAL_LOGIN_PATH } from "./auth";
import { getApiBase, portalApiUrl } from "./portalApiBase";

export { getApiBase, portalApiUrl } from "./portalApiBase";

export async function api(path, options = {}) {
  const { ...fetchOptions } = options;
  const token = getPortalToken();
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    ...(fetchOptions.headers || {}),
  };
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(portalApiUrl(path), {
    credentials: "include",
    ...fetchOptions,
    headers,
  });

  if (
    res.status === 401 &&
    typeof window !== "undefined" &&
    window.location.pathname.startsWith("/enterprise-portal/") &&
    window.location.pathname !== "/enterprise-portal"
  ) {
    clearPortalSession();
    window.location.assign(PORTAL_LOGIN_PATH);
  }

  return res;
}

export async function apiJson(path, options = {}) {
  const res = await api(path, options);
  const contentType = (res.headers.get("content-type") || "").toLowerCase();
  if (!contentType.includes("application/json")) {
    const hint =
      "Enterprise portal API returned HTML — check nyafaz-enterprise-portal (5135) and /enterprise-portal-api/.";
    throw new Error(res.ok ? hint : `Portal API error (${res.status}). ${hint}`);
  }
  const data = await res.json();
  return { res, data };
}
